import moment from "moment";
import _ from 'lodash';

export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}

export function formatJSDate(date?: Date) {
    if (!date) {
        return '';
    }
    const dt = new Date(date);
    return moment.utc(`${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}`).local().format('M/D/YYYY h:mm a');
}

export function isJSON(text: string) {
    try {
        JSON.parse(text);
        return true;
    } catch (e) {
        return false;
    }
}

export function sort<T>(items: T[], sortBy: keyof T | null, sortAsc: boolean): T[] {
    if (sortBy === null) {
        return items;
    }

    const sortDirection = sortAsc ? 'asc' : 'desc';
    const sortedItems = _.orderBy(items, [sortBy], [sortDirection]) as T[];
    return sortedItems;
}

export function getPage<T>(items: T[], page: number, pageSize: number): T[] {
    if (!items) {
        return items;
    }

    let pageItems = [] as T[];

    const startIndex = (page - 1) * pageSize;
    let endIndex = startIndex + pageSize;
    if (endIndex > items.length) {
        endIndex = items.length;
    }

    for (let i = startIndex; i < endIndex; i++) {
        pageItems.push(items[i]);
    }

    return pageItems;
}

export function getChildrenRecursive<T>(array: T[], getChildren: (item: T) => T[]): T[] {
	let items = [] as T[];
	array.forEach((item) => {
		items.push(item);
		const children = getChildrenRecursive(getChildren(item), getChildren);
		items.push.apply(items, children);
	});

	return items ? items : [];
}

export interface Path<T> {
    item: T;
    path: string[];
}

export function getPathsRecursive<T>(array: T[], base: string[], getPathName: (item: T) => string, getChildren: (item: T) => T[]): Path<T>[] {
    let paths = [] as Path<T>[];
    array.forEach((item) => {
        const path = { item, path: [...base, getPathName(item)] } as Path<T>;
        paths.push(path);
        const childPaths = getPathsRecursive(getChildren(item), path.path, getPathName, getChildren);
        childPaths.push.apply(paths, childPaths);
    });

    return paths ? paths : [];
}

export function stopClickPropogation(event: React.MouseEvent<unknown>) {
    event.stopPropagation();
}

export function containsSpecialCharacters(text: string) {
    return /[^A-Za-z0-9 ]/.test(text);
}

export function getFriendlySize(bytes: number) {
    const terrabytes = bytes * 0.000000000001;
    const gigabytes = bytes * 0.000000001;
    const megabytes = bytes * 0.000001;
    const kilobytes = bytes * 0.001;

    if (terrabytes > 1) {
        return `${terrabytes.toFixed(2)} TB`;
    } else if (gigabytes > 1) {
        return `${gigabytes.toFixed(2)} GB`;
    } else if (megabytes > 1) {
        return `${megabytes.toFixed(1)} MB`;
    } else if (kilobytes > 1) {
        return `${kilobytes.toFixed(0)} KB`;
    } else {
        return `${bytes} B`;
    }
}